import * as d3 from 'd3';
import type { OHLCVPoint } from '../../api/types';

const ohlcvBisect = d3.bisector<OHLCVPoint, Date>(d => d.t).left;

/** Find the nearest data point to `date` in a sorted OHLCVPoint array */
export function nearestOhlcv(
    data: OHLCVPoint[],
    date: Date
): OHLCVPoint | null {
    if (data.length === 0) return null;
    const idx = ohlcvBisect(data, date, 1);
    const d0 = data[idx - 1];
    const d1 = data[idx];
    if (!d0) return d1 ?? null;
    if (!d1) return d0;
    return date.getTime() - d0.t.getTime() < d1.t.getTime() - date.getTime()
        ? d0
        : d1;
}

/** Return the last OHLCV point at or before `date` (step-after semantics) */
export function floorOhlcv(data: OHLCVPoint[], date: Date): OHLCVPoint | null {
    if (data.length === 0) return null;
    const idx = ohlcvBisect(data, date, 1); // first index strictly after date
    return data[idx - 1] ?? null; // last one at or before date
}
